import type { JobPageProps } from './JobPage.types';
import { Button } from 'components/Button';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import { ArrowLeftIcon } from 'icons/outline';
import { JobHeader } from 'features/JobDetails/JobHeader';
import { JobSummary } from 'features/JobDetails/JobSummary';
import { JobQualifications } from 'features/JobDetails/JobQualifications';
import { JobActions } from 'features/JobDetails/JobActions';
import { EmployerJobActions } from 'features/JobDetails/EmployerJobActions';
import { JobAbout } from 'features/JobDetails/JobAbout';
import { JobLocations } from 'features/JobDetails/JobLocations';

export const JobPage = (props: JobPageProps) => {
  const { job, employerView } = props;
  const router = useRouter();

  const handleBack = () => {
    if (window.history.length === 1) {
      void router.push(`/jobs?jobId=${job.id}`);
      return;
    }
    router.back();
  };

  const handleClickLocations = () => {
    window.scrollTo({
      top: document.getElementById('job-locations').offsetTop,
      behavior: 'smooth',
    });
  };

  const renderActions = (className?: string) => {
    if (employerView) {
      return <EmployerJobActions className={clsx(className, 'max-md:flex-col')} job={job} />;
    }
    return <JobActions className={className} job={job} fullPage postHogLocation="Job Page" />;
  };

  return (
    <div className="relative h-full">
      <div className="w-full px-3 py-6 sm:px-6 sm:pt-10 sm:pb-12 sm:bg-neutral-no-white">
        <div className="lg:w-[calc((1280px_*_0.7)+((100vw-1280px)/2))] pl-[calc((100vw-1280px)/2_-_12px)] lg:pr-10">
          {!employerView && (
            <Button
              className="gap-2 mb-6 -mx-3 sm:mb-8"
              size="sm"
              variant="text"
              onClick={handleBack}
            >
              <ArrowLeftIcon className="w-4 h-4" />
              Back to search
            </Button>
          )}
          <JobHeader fullPage job={job} onClickMoreLocations={handleClickLocations} />
        </div>
      </div>

      <div className="px-3 py-4 sm:px-6">
        <div className="w-full lg:w-[calc((1280px_*_0.7)+((100vw-1280px)/2))] pl-[calc((100vw-1280px)/2_-_12px)] lg:pr-10">
          <JobSummary job={job} />
          <JobQualifications fullPage job={job} />
          <JobAbout job={job} />
          <JobLocations fullPage job={job} />
        </div>
      </div>

      <div className="max-lg:hidden absolute top-0 bottom-0 right-0 w-0 h-full bg-white z-0 lg:w-[calc((1280px_*_0.3)+((100vw-1280px)/2_-_12px))] lg:pr-[calc((100vw-1280px)/2_-_12px)]">
        <div className="w-full h-full pl-8 pr-3 lg:border-l border-neutral-light"></div>
      </div>

      {renderActions(
        'md:fixed sticky bottom-0 left-0 md:bottom-auto md:top-24 md:left-auto right-0 py-4 pl-4 sm:pl-6 pr-[calc(max(24px,(100vw-1280px)/2))] bg-white flex flex-wrap w-full md:w-max gap-4 rounded-l-lg shadow-box',
      )}
    </div>
  );
};

JobPage.displayName = 'JobPage';
